// Utils
import { getCenteredPopupPosition } from './getCenteredPopupPosition';
/**
 * @description Set inner element position to center of window
 *
 * @deprecated Do not use legacy components anymore.
 * @param {MutableRefObject<HTMLDivElement>} popupInnerElement Popup inner element
 * @param {(value: SetStateAction<FormBoxPosition>) => void} setPosition callback to set position
 * @param {BasePosition} basePosition Position the popup should relative to
 */
export var centerPopupPosition = function (popupInnerElement, setPosition, basePosition) {
    if (popupInnerElement.current) {
        var centeredPosition = getCenteredPopupPosition(popupInnerElement.current.offsetWidth, popupInnerElement.current.offsetHeight, basePosition);
        setPosition(centeredPosition);
    }
};
//# sourceMappingURL=centerPopupPosition.js.map